// extracted by mini-css-extract-plugin
module.exports = {"guide_share":"inviteSuccess_guide_share__26tU7","load_btn":"inviteSuccess_load_btn__1GuPF","mask":"inviteSuccess_mask__1jkdQ"};